import styled from 'styled-components';
import { purple } from '@material-ui/core/colors';

export const TimerBlockWrapper = styled.div`
  border: 1px solid var(--border-color);
  border-width: 1px 0;
  padding: 1em 0;
`;

export const TimerBlockTitle = styled.div`
  text-align: center;
  text-transform: uppercase;
`;

export const TimerBlockAmount = styled.span`
  color: ${purple[600]};
  font-weight: bold;
  margin: 0 0.5rem;
`;

export const TimerClock = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;

export const TimerClockTitle = styled.div`
  color: inherit;
  font-size: 0.6em;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
`;

export const TimerClockValue = styled.div`
  color: inherit;
  font-size: 2em;
  text-align: center;
  margin-bottom: 0.25rem;
`;
